import { useIntl } from 'react-intl';
import { Label } from 'ui/Label';
import { routes } from '../../../../../config/config';
import { ApplicationCertificate } from '../../../../../types/ListingData';
import { StyledCustomUploadList } from 'ui/Upload/Uploader/style';
import { CustomDocument } from 'ui/Upload/Uploader';
import { UploadFile } from 'antd';

interface CertificatesProps {
  certificates: ApplicationCertificate[];
  onDelete?: (certificate: ApplicationCertificate) => void;
}

export const Certificates = ({ certificates, onDelete }: CertificatesProps) => {
  const intl = useIntl();

  if (certificates.length === 0) {
    return null;
  }

  return (
    <div className="summary-section">
      <Label
        label={intl.formatMessage({
          id: 'listings.application.submitted_certificates',
        })}
        title={true}
      />
      <StyledCustomUploadList>
        {certificates.map((cert) => {
          const fileObj: any = (cert as any).file;
          const name =
            cert.file_name || fileObj?.original_name || fileObj?.name || '';
          const extFromName = name?.includes('.')
            ? name.split('.').pop()
            : undefined;
          const displayFormat = (
            extFromName ||
            cert.file_format ||
            fileObj?.mime_type ||
            ''
          )
            .toString()
            .toUpperCase();
          const displaySize = cert.file_size || fileObj?.size_bytes || 0;
          const uploadedAt = cert.created_at || fileObj?.created_at;

          const onDownload = () => {
            // Pending, not yet saved: download from local blob
            const origin = (cert as any).originFile as File | undefined;
            if (origin) {
              const objectUrl = URL.createObjectURL(origin);
              const a = document.createElement('a');
              a.href = objectUrl;
              a.download = name || 'certificate';
              a.click();
              URL.revokeObjectURL(objectUrl);
              return;
            }

            // Saved: use secure backend download
            if (fileObj?.url && cert.file_id && cert.listing_application_id) {
              const href = `${routes.api.baseUrl}/api/v2/listing-applications/${cert.listing_application_id}/certificates/download?file_id=${cert.file_id}`;
              window.open(href, '_blank');
              return;
            }
          };

          const fileUid = String(cert.id || Date.now());

          const handleDelete = (file: UploadFile) => {
            if (onDelete && file.uid === fileUid) {
              onDelete(cert);
            }
          };

          const fileForCustomDocument: UploadFile = {
            uid: fileUid,
            name: name,
            status: 'done',
            file_size: displaySize,
            file_format: displayFormat,
            created_at: uploadedAt,
          } as UploadFile;

          return (
            <CustomDocument
              key={cert.id}
              file={fileForCustomDocument}
              onDownload={onDownload}
              onDelete={onDelete ? handleDelete : undefined}
              showActions={true}
            />
          );
        })}
      </StyledCustomUploadList>
    </div>
  );
};
